import { Check, X } from "lucide-react";

const Node = ({ status }) => {
  if (status === "done") return <span className="w-8 h-8 rounded-full bg-[var(--g-dark,#3B1B48)] grid place-items-center"><Check className="w-4 h-4 text-[var(--g-accent,#C59B27)]" /></span>;
  if (status === "failed") return <span className="w-8 h-8 rounded-full bg-red-700 grid place-items-center"><X className="w-4 h-4 text-white" /></span>;
  if (status === "running") return <span className="w-8 h-8 rounded-full bg-[var(--g-accent,#C59B27)] pulse-node border-4 border-[#FAF7F2]" />;
  return <span className="w-8 h-8 rounded-full border border-[#E2D9CC] bg-[#FAF7F2]" />;
};

export const ProgressTimeline = ({ guide }) => (
  <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-12" data-testid="generation-progress">
    <div>
      <div className="flex items-baseline justify-between mb-3">
        <p className="eyebrow">Pipeline</p>
        <span data-testid="generation-progress-percent" className="font-display text-3xl text-[var(--g-dark,#3B1B48)]">{guide.progress}%</span>
      </div>
      <div className="h-1 bg-[#E2D9CC] mb-10"><div className="h-full bg-[var(--g-accent,#C59B27)] transition-[width] duration-700" style={{ width: `${guide.progress}%` }} /></div>
      <ol className="relative">
        {guide.steps.map((s, i) => (
          <li key={s.key} data-testid={`step-${s.key}`} className="flex gap-5 pb-8 relative">
            {i < guide.steps.length - 1 && <span className="absolute left-4 top-8 bottom-0 w-px bg-[#E2D9CC]" />}
            <Node status={s.status} />
            <div>
              <p className={`font-display text-lg ${s.status === "pending" ? "text-[#8C827A]" : "text-[var(--g-dark,#3B1B48)]"}`}>{s.label}</p>
              {s.detail && <p className="text-sm text-[#8C827A]">{s.detail}</p>}
            </div>
          </li>
        ))}
      </ol>
    </div>
    <div className="bg-[#1C181D] text-[var(--g-mist,#EFE6F3)] p-6 font-mono-accent text-xs leading-6 min-h-[360px] max-h-[520px] overflow-auto" data-testid="generation-log">
      <p className="text-[var(--g-accent,#C59B27)] mb-3">// studio log</p>
      {guide.logs.map((l, i) => <p key={i} className={l.startsWith("ERROR") ? "text-red-400" : ""}>{l}</p>)}
      {!["done", "failed"].includes(guide.status) && <p className="animate-pulse">▍</p>}
    </div>
  </div>
);
